import bannerImg from './banners/woman-helping-man-gym.jpg';

const acompanhamentoNutricional = (t) => ({
    id: 'acompanhamento-nutricional',
    title: t('templates.items.acompanhamentoNutricional.title'),
    description: t('templates.items.acompanhamentoNutricional.description'),
    indicatedFor: t('templates.audiences.nutritionists'),
    stepsCount: 1,
    questionsSummary: [
        t('templates.items.acompanhamentoNutricional.summary.planAdherence'),
        t('templates.items.acompanhamentoNutricional.summary.weeklyWeight'),
        t('templates.items.acompanhamentoNutricional.summary.difficulties'),
        t('templates.items.acompanhamentoNutricional.summary.energy'),
    ],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: t('templates.items.acompanhamentoNutricional.form.title'),
        active: false,
        allow_multiple_answers: true,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: t('templates.items.acompanhamentoNutricional.form.checkIn.title'),
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: t('templates.items.acompanhamentoNutricional.form.checkIn.submit'),
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'scale',
                        label: t('templates.items.acompanhamentoNutricional.form.checkIn.adherence.label'),
                        description: null,
                        required: true,
                        settings: {
                            min: 1,
                            max: 5,
                            minLabel: t('templates.items.acompanhamentoNutricional.form.checkIn.adherence.minLabel'),
                            maxLabel: t('templates.items.acompanhamentoNutricional.form.checkIn.adherence.maxLabel'),
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                    {
                        order: 2,
                        type: 'weight',
                        label: t('templates.items.acompanhamentoNutricional.form.checkIn.weight.label'),
                        description: null,
                        required: false,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'text',
                        label: t('templates.items.acompanhamentoNutricional.form.checkIn.difficulties.label'),
                        description: null,
                        required: false,
                        settings: null,
                    },
                    {
                        order: 4,
                        type: 'scale',
                        label: t('templates.items.acompanhamentoNutricional.form.checkIn.energy.label'),
                        description: null,
                        required: true,
                        settings: {
                            min: 1,
                            max: 5,
                            minLabel: t('templates.items.acompanhamentoNutricional.form.checkIn.energy.minLabel'),
                            maxLabel: t('templates.items.acompanhamentoNutricional.form.checkIn.energy.maxLabel'),
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                ],
            },
        ],
        actions: [],
    },
});

export default acompanhamentoNutricional;
